export const QRSteps = () => {
  return (
    <div>
      <div className="flex mb-4">
        <div className="leading-6 font-semibold text-primary-p3 shrink-0">
          Step 1
        </div>
        <div className="text-base leading-snug pl-4">
          Scan to download the OneStep app
        </div>
      </div>
      <div className="flex">
        <div className="leading-6 font-semibold text-primary-p3 shrink-0">
          Step 2
        </div>
        <div className="text-base leading-snug pl-4">
          Scan again after downloading to log in to the OneStep app
        </div>
      </div>
    </div>
  );
};
